import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-delete',
	path: '/secure/admin/DeleteCustomField!default.jspa',
};
